/**
 * Deduplicate analyses by depot: keep only the latest analysis per depotId.
 * Works with any array of objects that have `depotId` (or fallback key) and `createdAt`.
 */
export function deduplicateAnalysesByDepot<
  T extends { depotId?: string; depot_id?: string; createdAt?: string; created_at?: string },
>(analyses: T[]): T[] {
  const latestByDepot = new Map<string, T>();

  for (const analysis of analyses) {
    const depotId = analysis.depotId ?? analysis.depot_id;
    if (!depotId) continue;

    const existing = latestByDepot.get(depotId);
    if (!existing) {
      latestByDepot.set(depotId, analysis);
      continue;
    }

    const existingDate = existing.createdAt ?? existing.created_at ?? "";
    const currentDate = analysis.createdAt ?? analysis.created_at ?? "";
    if (currentDate > existingDate) {
      latestByDepot.set(depotId, analysis);
    }
  }

  return Array.from(latestByDepot.values());
}
